import React from 'react';
import styles from './index.module.styl';
import { HypothesisSummaryCard } from './_hypothesis-card';
import { ExposuresSummaryCard } from './_exposures-card';
import { ExperimentPageSummaryMetrics } from './_metrics';
import { ExperimentPageBanner } from './_banner';
export function ExperimentPageSummary() {
  return <div className={styles.summary} data-sentry-component="ExperimentPageSummary" data-sentry-source-file="index.tsx">
      <ExperimentPageBanner data-sentry-element="ExperimentPageBanner" data-sentry-source-file="index.tsx" />
      <div className={styles.summaryCards}>
        <HypothesisSummaryCard className={styles.summaryCard} data-sentry-element="HypothesisSummaryCard" data-sentry-source-file="index.tsx" />
        <ExposuresSummaryCard className={styles.summaryCard} data-sentry-element="ExposuresSummaryCard" data-sentry-source-file="index.tsx" />
      </div>
      <ExperimentPageSummaryMetrics data-sentry-element="ExperimentPageSummaryMetrics" data-sentry-source-file="index.tsx" />
    </div>;
}